var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._b(
      { staticClass: "assistant-blocks" },
      "div",
      _vm.MOLDURA_DO_THREAD,
      false
    ),
    [
      _vm.mostraPlano
        ? _c("PlanoProgress", { attrs: { itens: _vm.plano.itens } })
        : _vm._e(),
      _vm.mostraRaciocinio
        ? _c("RaciocinioLinha", {
            attrs: {
              passos: _vm.passos,
              "passo-atual": _vm.passoAtual,
              "passo-de-trabalho": _vm.passoDeTrabalho,
              streaming: _vm.streaming,
              "duracao-segundos": _vm.duracaoSegundos,
              "rotulo-do-tempo": _vm.rotuloDoTempo,
              auxiliares: _vm.auxiliares,
              erro: _vm.erroDoTurno
            }
          })
        : _vm._e(),
      _vm.temPainel
        ? _c("PainelDeliberacao", {
            attrs: {
              painel: _vm.painel,
              "em-andamento": _vm.streaming,
              recolher: !_vm.streaming
            }
          })
        : _vm._e(),
      _vm._t("antes-do-texto"),
      _vm._t("default"),
      _vm.temPainel
        ? [
            _vm.mostraProximosPassos
              ? _c("NextSteps", { attrs: { passos: _vm.proximosPassos } })
              : _vm._e(),
            _vm.mostraPerguntas
              ? _c("OpenQuestions", { attrs: { perguntas: _vm.perguntas } })
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }